import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default class extends React.Component {

	static propTypes = {
		mask: PropTypes.string.isRequired,
		maskChar: PropTypes.string,
		placeholder: PropTypes.string,
		formatChars: PropTypes.object,
		onChange: PropTypes.func,
		onChangeOverride: PropTypes.func,
		alwaysShowMask: PropTypes.bool,
	};

	onChange = e => {
		if (this.props.onChangeOverride) {
			console.log('MaskedInput onChangeOverride', e.target.value);
			this.props.onChangeOverride(e);
		}
		else if (this.props.onChange) {
			this.props.onChange(e);
		}
	};

	render() {
		const { onChangeOverride, ...rest } = this.props;
		return (
			<InputMask {...rest} onChange={this.onChange}/>
		);
	}

}
